import http from '../../../utils/tools/http';

import {
  CENTER_FETCH_GET_LOOK_INFO_BEGIN,
  CENTER_FETCH_GET_LOOK_INFO_SUCCESS,
  CENTER_FETCH_GET_LOOK_INFO_FAILURE,
  CENTER_FETCH_GET_LOOK_INFO_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchGetLookInfo(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CENTER_FETCH_GET_LOOK_INFO_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = http.get({ url: "/datastore/WebCourse/GetCourseLookInfo", params: args });
      doRequest.then(
        (res) => {
          dispatch({
            type: CENTER_FETCH_GET_LOOK_INFO_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CENTER_FETCH_GET_LOOK_INFO_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchGetLookInfoError() {
  return {
    type: CENTER_FETCH_GET_LOOK_INFO_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CENTER_FETCH_GET_LOOK_INFO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchGetLookInfoPending: true,
        fetchGetLookInfoError: null,
      };

    case CENTER_FETCH_GET_LOOK_INFO_SUCCESS:
      // The request is success
      let arr = [];
      let d = action.data.Data;

      if (d) {
        let arrlite = [d[0]]; //缓存第一个数据到二级数组
        for (let i = 1; i < d.length; i++) {
          let a = d[i - 1].LookDate;
          let b = d[i].LookDate;
          if (a === b) {// 追加到二级数组缓存
            arrlite.push(d[i]);
          } else {//追加到一级数组  重置二级数组
            arrlite.length > 0 && arr.push(arrlite);
            arrlite = [];
            arrlite.push(d[i]);
          }
          if (i === d.length - 1) { // 遍历比对当前二级数组完成 将二级数组缓存对象 追加到一级数组
            arr.push(arrlite)
          }
        }
        if (d.length === 1) { //只有一个
          arr.push(arrlite)
        }
      }
      return {
        ...state,
        fetchGetLookInfoPending: false,
        fetchGetLookInfoSuccess: arr,
      };

    case CENTER_FETCH_GET_LOOK_INFO_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchGetLookInfoPending: false,
        fetchGetLookInfoError: action.data.error,
      };

    case CENTER_FETCH_GET_LOOK_INFO_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchGetLookInfoError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/center/redux/fetchGetLookInfo.js